import React, { Fragment } from 'react'

import _ from 'lodash'
import ContentLoader from 'react-content-loader'
import { createPortal } from 'react-dom'
import ReactLoading from 'react-loading'

import { EmptyAlert as _EmptyAlert } from './Alerts/EmptyAlert'
import { ErrorAlert } from './Alerts/ErrorAlert'
import { LoadingAlert } from './Alerts/LoadingAlert'

export const CardsLoader = ({ itemsPerRow, itemHeight = 250 }) => {
  return (
    <div className={`grid gap-4`} style={{ gridTemplateColumns: `repeat(${itemsPerRow}, minmax(0, 1fr))` }}>
      {_.range(0, itemsPerRow).map(index => (
        <div key={index}>
          <ContentLoader style={{ width: '100%', height: itemHeight }}>
            <rect x={0} y={0} rx="12" ry="12" width={'100%'} height={'100%'} />
          </ContentLoader>
        </div>
      ))}
    </div>
  )
}

export const WordContentLoader = ({
  height,
  width,
  isLoading,
  children,
  ...rest
}) =>
  isLoading ? (
    <ContentLoader
      height={height}
      width={width}
      preserveAspectRatio="none"
      {...rest}
    >
      <rect x="0" y="0" rx="6" ry="6" height={height} width={width} />
    </ContentLoader>
  ) : (
    children
  )

export const LoadWrapper = ({
  isLoading,
  isError,
  isEmpty,
  EmptyAlert = _EmptyAlert,
  tableCols,
  cardsPerRow,
  itemHeight,
  className = '',
  skeleton,
  fullscreen,
  children
}) => {
  if (isLoading || isError || isEmpty) {
    if (tableCols) {
      return (
        <>
          {isLoading && (
            <>
              {skeleton
                ? skeleton
                : _.range(0, 12).map(trIndex => (
                    <tr key={trIndex}>
                      {_.range(0, tableCols).map(index => (
                        <td key={`table-row-${index}`}>
                          <ContentLoader
                            height="40"
                            width="100%"
                            preserveAspectRatio="none"
                            rtl={index > 0}
                          >
                            {index == 0 && (
                              <>
                                <rect
                                  x="0"
                                  y="0"
                                  rx="6"
                                  ry="6"
                                  width="40"
                                  height="40"
                                />
                                <rect
                                  x="50"
                                  y="8"
                                  rx="4"
                                  ry="4"
                                  width="180"
                                  height="10"
                                />
                                <rect
                                  x="50"
                                  y="24"
                                  rx="4"
                                  ry="4"
                                  width="120"
                                  height="8"
                                />
                              </>
                            )}
                            {index > 0 && index < tableCols - 1 && (
                              <>
                                <rect
                                  x="0"
                                  y="8"
                                  rx="4"
                                  ry="4"
                                  width="80"
                                  height="12"
                                />
                              </>
                            )}
                            {index == tableCols - 1 && (
                              <>
                                <rect
                                  x="0"
                                  y="0"
                                  rx="4"
                                  ry="4"
                                  width="34"
                                  height="34"
                                />
                                <rect
                                  x="40"
                                  y="0"
                                  rx="4"
                                  ry="4"
                                  width="34"
                                  height="34"
                                />
                              </>
                            )}
                          </ContentLoader>
                        </td>
                      ))}
                    </tr>
                  ))}
            </>
          )}
          {isError && (
            <tr>
              <td colSpan={tableCols}>
                <ErrorAlert />
              </td>
            </tr>
          )}
          {isEmpty && (
            <tr>
              <td colSpan={tableCols}>
                <EmptyAlert />
              </td>
            </tr>
          )}
        </>
      )
    }

    if (cardsPerRow) {
      return (
        <>
          {isLoading && (
            <CardsLoader itemsPerRow={cardsPerRow} itemHeight={itemHeight} />
          )}
          <div className="col-span-full">
            {isError && <ErrorAlert />}
            {isEmpty && <EmptyAlert />}
          </div>
        </>
      )
    }

    if (fullscreen)
      return createPortal(
        <div
          className="fixed inset-0 flex items-center justify-center z-page-loader"
        >
          <div className="absolute inset-0 bg-white opacity-25"></div>
          <span className="relative">
            <ReactLoading
              type="bubbles"
              color="#3F4254"
              height={50}
              width={50}
            />
          </span>
        </div>,
        document.body
      )

    return (
      <>
        {isLoading && (
          <>{skeleton ? skeleton : <LoadingAlert className={className} />}</>
        )}
        {isError && <ErrorAlert className={className} />}
        {isEmpty && <EmptyAlert className={className} />}
      </>
    )
  }

  return children
}
